<template>
    <div v-if="available" class="c-stt" @blur="stopRecording">
        <v-wave class="c-stt__wave" :class="{ 'c-stt__wave--shown' : recording }"></v-wave>
        <button
            v-show="recording"
            tabindex="-1"
            type="button"
            class="c-stt__stop"
            title="Zatrzymaj nasłuchiwanie"
            @click="stopRecording">
        </button>
        <button
            v-show="!recording"
            tabindex="-1"
            type="button"
            class="c-stt__mic"
            title="Rozpocznij nasłuchiwanie"
            @click="startRecording">
        </button>
    </div>
</template>


<script>

import VWave from 'Components/VWave'

export default {
    name: 'VSpeechToText',

    props: {
        value: String
    },

    data() {
        return {
            recognition: null,
            available: false,
            recording: false,
            previousValue: null
        }
    },

    methods: {
        onResult(e) {
            var current = e.resultIndex
            var transcript = e.results[current][0].transcript
            var mobileRepeatBug = (current == 1 && transcript == e.results[0][0].transcript)

            var text = ''

            for (let i = 0; i < e.results.length; i++) {
                text += e.results[i][0].transcript
            }

            if (!mobileRepeatBug) {
                this.$emit('speaking', this.previousValue + this.capitalizeFirstLetter(text))
            }
        },
        stopRecording() {
            this.recording = false
            this.recognition.stop()
        },
        startRecording() {
            this.previousValue = this.value || ''
            this.previousValue += this.previousValue.trim() ? '. ' : ''
            this.recognition.start()
        },
        onStartRecording() {
            this.recording = true
        },
        onEndRecording() {
            this.recording = false
        },
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        onError(event) {
            this.stopRecording()
            console.log(event.error)
            if (event.error == 'no-speech') {
                console.log('Nie wykryto głosu spróbuj ponownie');
            } else {
                console.log('Wystąpił błąd spróbuj ponownie');
            }
        }
    },

    mounted() {
        try {
            var SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
            this.recognition = new SpeechRecognition()
            this.available = true

            this.recognition.maxAlternatives = 1
            this.recognition.continuous = true
            this.recognition.interimResults = true
            this.recognition.lang = 'pl'
            this.recognition.onresult = this.onResult
            this.recognition.onstart = this.onStartRecording
            this.recognition.onspeechend = this.onEndRecording
            this.recognition.onError = this.onError

        } catch (e) {
            this.available = false
        }

        document.addEventListener('click', () => {
            if (this.recording) {
                this.stopRecording()
            }

        })
    },

    beforeDestroy() {
        this.$off('stop')
    },

    components: {
        VWave
    }
}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-stt {
    display: flex;
    height: calc(2.4rem - 2px);
    padding: 0 0.4rem;
    align-items: center;
    border-radius: 0.25rem;
    background-color: $c-white;

    &:focus {
        background-color: #f00;
    }
    &__mic,
    &__stop {
        display: inline-block;
        width: 1.6rem;
        height: 1.6rem;
        border: 0;
        outline: 0;
        border-radius: 50%;
        background-color: #DCE0E6;
        background-position: center;
        background-repeat: no-repeat;
        margin-left: 0.7rem;
        cursor: pointer;
    }
    &__mic {
        background-image: url('#{$icons}/mic.svg');
        background-size: 0.6rem 0.9rem;
    }
    &__stop {
        background-image: url('#{$icons}/stop.svg');
        background-size: 0.5rem 0.5rem;
    }
    &__wave {
        display: inline-block;
        opacity: 0;
        transform: scale(1, 0);
        transition: opacity .2s ease-in-out, transform .2s ease-in-out;

        &--shown {
            opacity: 1;
            transform: scale(1, 1);
        }
    }
}

</style>

